// src/components/layout/Header.tsx
//
// Top-bar — Certain® brand mark + current-app pill (`/ ARM`) + user menu.
// Per design system §6.10: the suite brand mark lives here, never replaced
// by the customer's logo. The workspace logo appears in ModuleHeader instead.

import { useSnapshot } from 'valtio';
import { authState } from '../../stores/authStore';
import { UserProfileMenu } from '../auth/UserProfileMenu';

export function Header() {
  const auth = useSnapshot(authState);
  const companyName = auth.user?.companyName;

  return (
    <div
      className="h-16 flex items-center justify-between flex-shrink-0 px-6 border-b print:hidden"
      style={{
        background: 'var(--color-bg)',
        borderColor: 'var(--color-border)',
      }}
    >
      {/* Brand: favicon (32px) + Certain® wordmark + "/ ARM" pill */}
      <div className="flex items-center gap-3 min-w-0">
        <img
          src="/certain-favicon.png"
          alt=""
          className="w-8 h-8 flex-shrink-0"
          aria-hidden="true"
        />
        <h1
          className="text-base font-bold tracking-tight m-0"
          style={{ color: 'var(--color-text)' }}
        >
          Certain
          <span
            className="font-medium ml-px"
            style={{
              fontSize: '0.55em',
              verticalAlign: 'super',
              lineHeight: 0,
              color: 'var(--color-text-muted)',
            }}
          >
            ®
          </span>
        </h1>
        <span className="font-medium" style={{ color: 'var(--color-text-subtle)' }}>
          /
        </span>
        <span
          className="font-medium text-sm whitespace-nowrap"
          style={{ color: 'var(--color-text-muted)' }}
        >
          ARM
        </span>
        {companyName && (
          <>
            <span
              className="font-medium ml-1 hidden sm:inline"
              style={{ color: 'var(--color-text-subtle)' }}
            >
              ·
            </span>
            <span
              className="text-sm truncate hidden sm:inline"
              style={{ color: 'var(--color-text-muted)' }}
            >
              {companyName}
            </span>
          </>
        )}
      </div>

      <UserProfileMenu />
    </div>
  );
}
